<template>
  <div v-if="value">
    <a :href="computedLink" v-if="computedHasLink">{{ value }}</a>
    <span v-if="!computedHasLink">{{ value }}</span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          v-clipboard:copy="value"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          small
          icon
          v-on="on"
        >
          <v-icon>content_paste</v-icon>
        </v-btn>
      </template>
      <span>{{ `Copy ${value} to clipboard` }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "Telephone",
  props: ["value"],
  computed: {
    computedHasLink() {
      return (
        this.value && (this.value.startsWith("0") || this.value.startsWith("+"))
      );
    },
    computedLink() {
      return `tel:${this.value}`;
    }
  },
  methods: {
    onCopy() {
      this.$emit("onCopy", this.value);
    },
    onError() {
      this.$emit("onError", this.value);
    }
  }
};
</script>